import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import AboutModal from './AboutModal';
import ServicesModal from './ServicesModal';
import ContactModal from './ContactModal';
import * as FiIcons from 'react-icons/fi';

const { FiInstagram, FiMail } = FiIcons;

const Footer = () => {
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showServicesModal, setShowServicesModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <>
      <footer className="bg-white text-slate-600 border-t border-slate-200">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center space-x-2 mb-4">
                <img src="https://folder.host/images/2025/11/16/clink-logo.png" alt="Chaldean Link Logo" className="h-8 w-auto" />
              </Link>
              <p className="text-sm text-slate-500 max-w-xs">
                The smarter way to find Chaldean businesses, professionals, and creators on Instagram.
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-slate-900 mb-4">Explore</h3>
              <ul className="space-y-3 text-sm">
                <li><Link to="/" className="hover:text-slate-900 transition-colors">Directory</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-slate-900 mb-4">Company</h3>
              <ul className="space-y-3 text-sm">
                <li><button onClick={() => setShowAboutModal(true)} className="hover:text-slate-900 transition-colors text-left">About Us</button></li>
                <li><button onClick={() => setShowServicesModal(true)} className="hover:text-slate-900 transition-colors text-left">Services</button></li>
                <li><button onClick={() => setShowContactModal(true)} className="hover:text-slate-900 transition-colors text-left">Contact Us</button></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-slate-900 mb-4">Connect</h3>
              <div className="flex space-x-4">
                <a href="https://instagram.com/chaldeanlink" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-slate-800 transition-colors">
                  <SafeIcon icon={FiInstagram} className="text-xl" />
                </a>
                <a href="mailto:hi@chaldeanlink.com" className="text-slate-500 hover:text-slate-800 transition-colors">
                  <SafeIcon icon={FiMail} className="text-xl" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-200 mt-8 pt-6 text-sm text-slate-500">
            <p>&copy;{new Date().getFullYear()} Chaldean Link. All rights reserved.</p>
          </div>
        </div>
      </footer>
      <AboutModal isOpen={showAboutModal} onClose={() => setShowAboutModal(false)} />
      <ServicesModal isOpen={showServicesModal} onClose={() => setShowServicesModal(false)} />
      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
    </>
  );
};

export default Footer;